module.exports = __webpack_public_path__ + "static/photogif-3067ca4fa616a98a8e5700ea3a71c927.gif";